import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class CountryService {
    private countriesUrl = 'assets/countries.json';
    constructor(private http: HttpClient) {}

    getCountries(): Observable<any[]> {
        return this.http.get<any[]>(this.countriesUrl);
        //return this.http.get<any[]>(`${this.apiUrlBackend}`);
    }
}
